import { render, staticRenderFns } from "./DaumPostcodeWindow.vue?vue&type=template&id=48634a3e&scoped=true"
import script from "./DaumPostcodeWindow.vue?vue&type=script&lang=js"
export * from "./DaumPostcodeWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48634a3e",
  null
  
)

export default component.exports